import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { formatTime } from "../utils";
import styled from "styled-components";

const formatDate = (dateValue) => {
  if (!dateValue) return null;
  let dateObj;
  if (dateValue instanceof Date) {
    dateObj = dateValue;
  } else if (typeof dateValue === "string") {
    dateObj = new Date(dateValue + "T00:00:00"); // The string is added as the date is in our time zone already
    if (isNaN(dateObj.getTime())) return null; // Invalid date
  } else {
    return null;
  }
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const AppointmentRequestLinkButton = ({
  toDoListID,
  appointmentRequestID,
  attachedUser,
  date,
  time,
  location,
  toDoListTaskType,
  isToDoListRecurring
}) => {
  if (!(toDoListTaskType === "Appointment" || toDoListTaskType === "Appointment (All locations)"))
    return <></>;
  const path = useMemo(() => {
    if (isToDoListRecurring) return `/manage_appointment_requests/${toDoListID}`;
    if (appointmentRequestID) return `/appointment_request_edit/${appointmentRequestID}`;
    const basePath = `/appointment_request_new/${toDoListID}`;

    const params = new URLSearchParams();
    const formattedTime = new Date(time);
    if (date) params.append("date", formatDate(date));
    if (time)
      params.append("time", formatTime(formattedTime.getHours(), formattedTime.getMinutes()));
    if (location) params.append("location", encodeURIComponent(location));

    return params.toString() ? `${basePath}?${params.toString()}` : basePath;
  });

  const text = useMemo(() => {
    if (isToDoListRecurring) return "Manage Appointment Requests";
    return appointmentRequestID ? "Edit Appointment Request" : "Add Appointment Request";
  });

  return (
    <div className="appointment-request-action">
      <StyledLinkButton
        href={path}
        className="ccw-button ccw-button--primary todo-action-button todo-action-button--appointment appointment-request-link-button bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        <strong>{text}</strong>
      </StyledLinkButton>
      {attachedUser && (
        <span className="appointment-request-action__peer">Matched Peer: {attachedUser}</span>
      )}
    </div>
  );
};

export default AppointmentRequestLinkButton;

const StyledLinkButton = styled.a`
  margin: 0;
`;

AppointmentRequestLinkButton.propTypes = {
  editMode: PropTypes.bool,
  appointmentRequestID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  date: PropTypes.string,
  time: PropTypes.string,
  location: PropTypes.string,
  toDoListID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  toDoListTaskType: PropTypes.string,
  isToDoListRecurring: PropTypes.bool,
  attachedUser: PropTypes.string
};

AppointmentRequestLinkButton.defaultProps = {
  editMode: false,
  appointmentRequest: undefined,
  date: undefined,
  time: undefined,
  location: undefined,
  isToDoListRecurring: false
};
